import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ContextFactoryService {
  GENERAL_CONFIG: any = {};
  contextFactory: any = {
    context_key: null,
    contextObject: {},
  };
  URLS: any = {
    FETCH: '/loadContextObject',
  };

  constructor(private http: HttpClient) {
    this.GENERAL_CONFIG = environment;
  }

  clearContext(): void {
    this.contextFactory.context_key = null;
  }

  setContextKey(_context_key: any): void {
    this.contextFactory.context_key = _context_key;
  }

  getContextObj() {
    const body = new FormData();
    body.append('context_key', this.contextFactory.context_key);
    return this.http.post(
      this.GENERAL_CONFIG.base_url + this.URLS.FETCH,
      body,
      { withCredentials: true }
    );
  }
}
